import React from "react";
import "../../styles/LandingPageHeader.css";
import { useNavigate } from "react-router-dom";
import ArrowUpRight from "../../assets/logos/ArrowUpRight.svg";

const LandingPageHeader = ({ companyName, subscriptionTier }) => {
  const navigate = useNavigate();
  return (
    <div className="LandingPageHeader">
      <div className="LandingPageCover" data-testid="landing-header">
        <p>
          {companyName}
        </p>
        <h1>
          Intelligent Virtual Assistant (IVA) is a cutting-edge solution designed to empower
          {' '}
          <br />
          businesses with AI-driven insights and decision-making tools.
          <br />
        </h1>
        <div className="LandingPageButtons">
          <div
            className="LandingPageButton"
            onClick={() => navigate("/chat?new_chat=true")}
          >
            <span className="ChatNow">Chat Now</span>
            <img src={ArrowUpRight} alt="ArrowUpRight" className="ArrowUpRight" />
          </div>
          <div
            className="LandingPageButton"
            // onClick={() => navigate("http://localhost:3001/apps")}
            onClick={() => navigate("/apps")}
          >
            <span className="ChatNow">Go to Apps</span>
            <img src={ArrowUpRight} alt="ArrowUpRight" className="ArrowUpRight" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default LandingPageHeader;
